import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './utils/reportWebVitals';
import { PostHogProvider } from '@posthog/react';

// A linha mágica está adicionada aqui embaixo: person_profiles: 'always'
const options = {
  api_host: 'https://us.i.posthog.com',
  defaults: '2026-05-30',
  person_profiles: 'always' 
};

const POSTHOG_KEY = 'phc_CjxH3kJpyfioQHJcwpjwFU5ZsH4GHQ5zcNQhv6ZZMvwV'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PostHogProvider apiKey={POSTHOG_KEY} options={options}>
      <App />
    </PostHogProvider>
  </React.StrictMode>
);

reportWebVitals();